export default __webpack_public_path__ + "static/media/(4).077e6b67.jpg";